module.exports = __webpack_public_path__ + "img/16l011-06.a5b781a4.png";